import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/ArticleCard";

export default function LatestArticles() {
  const latest = articles.slice(0, 8);

  return (
    <section className="bg-background-50 py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <p className="text-xs uppercase tracking-widest text-foreground-500 mb-3 font-label">
              最新更新
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
              新鲜热瓜
            </h2>
          </div>
          <Link
            to="/category/celebrity-gossip"
            className="text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {latest.map((article) => (
            <ArticleCard key={article.id} article={article} variant="default" />
          ))}
        </div>
      </div>
    </section>
  );
}